import { render, staticRenderFns } from "./contract-partner-card.vue?vue&type=template&id=0b4b8026&"
import script from "./contract-partner-card.ts?vue&type=script&lang=js&"
export * from "./contract-partner-card.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../../Locales/contract-partner-locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CInpulse%5CInpulse4Utilities%5CInpulse4Utilities.Web%5CAreas%5CNewContract%5CScripts%5CPKS%5Csteps%5Ccomponents%5Ccontract-partner-card.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports